import React from 'react';
import { Öffnen, Löschen } from '../../icons';
import './IconButton.css';

export function IconButton({ variant, label, onClick, disabled }) {
  return (
    <button
      type="button"
      className={`icon-button ${variant}`}
      aria-label={label}
      title={label}
      onClick={onClick}
      disabled={disabled}
    >
      <span aria-hidden="true">
        {variant === 'open' ? <Öffnen /> : <Löschen />}
      </span>
    </button>
  );
}
